import { createAction } from 'redux-actions';

export const toggleMobileMenu = createAction('TOGGLE_MOBILE_MENU');
